import { useIsMobile } from '../../../utils/isMobile';
import ContactFormMobile from './ContacFormMobile';
import ContactFormDesktop from './ContactFormDesktop';
import type { ContactFormProps } from './ContactFormDesktop';

export default function ContactForm(props: ContactFormProps) {
  const isMobile = useIsMobile();
  return isMobile
    ? <ContactFormMobile {...props} />
    : <ContactFormDesktop {...props} />;
}